module.exports = __webpack_public_path__ + "static/media/crosssnap.beea98cc.svg";